import React from "react";
import styled from "styled-components";
import BACKGROUNDIMAGE from "../../assets/img/backgroundImageCrew.png";
import { BackButton } from "../../styles/AddAdherense";
import { useNavigate } from "react-router-dom";
import { HOME_LOGGED } from "../../core/app-urls";

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e6f2ff;
  font-family: Arial, sans-serif;
`;

const WrapContent = styled.div`
  height: 500px;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background: #e5f8fa;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: self-start;
  z-index: 1;
  position: relative;
`;

export const StaticImage = styled.img`
  position: absolute;
  height: 100%; 
  top: -20px;
  pointer-events: none;
  right: 0;
  z-index: 0;
  transform: rotateX(180deg);
`

const Logo = styled.div`
  background: black;
  color: white;
  font-weight: bold;
  padding: 10px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #FF5742;
`;

const Subtitle = styled.div`
  font-size: 16px;
  color: #3366cc;
`;

const Section = styled.div`
  margin-top: 20px;
`;

const Label = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #003366;
  z-index: 1;
  position: relative;
`;

const InfoBox = styled.div`
  background: rgba(236, 250, 255, 0.7); 
  padding: 15px;
  border-radius: 5px;
  margin-top: 5px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
  z-index: 1;
  position: relative;
`;

const InfoText = styled.div`
  font-size: 20px;
  color: #FF5641;
  margin: 5px 0;
`;

const Footer = styled.div`
  font-size: 18px;
  color: #3366cc;
  margin-top: 20px;
  align-self: self-start;
  z-index: 1;
  `;

const DevelopedBy = styled.div`
  font-size: 15px;
  color: black;
  margin-top: 20px;
  text-align: center;
  align-self: self-start;
`;

export default function EnterpriseRegister() {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate(HOME_LOGGED);
  };

  return (
    <Container>
      <Card>
        <StaticImage src={BACKGROUNDIMAGE} />
        <WrapContent>
          <BackButton onClick={handleLogout}>VOLTAR</BackButton>
          <Header>
            {/* <Logo>WBC</Logo> */}
            <div>
              <Title>Olá, {localStorage.getItem("name")}</Title>
              <Subtitle>Seja bem-vindo ao PORTAL DO CLIENTE</Subtitle>
            </div>
          </Header>
          <Section>
            <Label>Cadastro da empresa</Label>
            <InfoBox>
              <InfoText>Razão social: {localStorage.getItem("name")}</InfoText>
              <InfoText>CEP: {localStorage.getItem("cep")}</InfoText>
              <InfoText>Cidade: {localStorage.getItem("city")}</InfoText>
              <InfoText>Rua: {localStorage.getItem("street")}</InfoText>
              <InfoText>Número: {localStorage.getItem("number")}</InfoText>
              <InfoText>
                Telefone de contato: {localStorage.getItem("cellphone")}
              </InfoText>
              <InfoText>E-mail: {localStorage.getItem("email")}</InfoText>
            </InfoBox>
          </Section>
          <Footer>
            Caso necessite de uma atualização das informações acima, entre em
            contato com a unidade.
          </Footer>
          <DevelopedBy>Developed by WBC SISTEMAS</DevelopedBy>
        </WrapContent>
      </Card>
    </Container>
  );
}
